import { exists } from '@/helpers/utilities';
import Swiper from 'swiper';
import { Autoplay, Pagination, EffectFade } from 'swiper/modules'
Swiper.use([Autoplay, Pagination, EffectFade]);
// import Swiper from 'swiper/bundle';


let HeroSlideshow = (() => {
    class HeroSlideshow {
        constructor(selector) {
            this.node = document.querySelector(selector);
            this.nodeExists = exists(this.node);
            if (!this.nodeExists) return;
            

            this.initSwiper();
            
        }

        initSwiper() {
            const autoplayDelay = this.node.getAttribute('data-autoplaydelay');
            
            this.swiper = new Swiper(this.node, {
                slidesPerView: 1,
                spaceBetween: 30,
                loop: true,
                effect: "fade",
                crossFade: true,
                fadeEffect: { crossFade: true},
                autoplay: {
                    delay: autoplayDelay,
                    disableOnInteraction: false,
                },
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
            });
        }
    }

    return {
        init({ selector }) {
            return new HeroSlideshow(selector);
        },
    };

})();

export default HeroSlideshow;
